import SV from 'server-vars';
import { type MouseEvent } from 'react';
import { LOCALE_US } from 'dibs-intl/exports/locales';
import { trackEvent, trackEcommerce, trackingConstants, eventNameConstants } from 'dibs-tracking';

import { type PdpRespUnavailableHeaderYMAL_viewer$data } from './__generated__/PdpRespUnavailableHeaderYMAL_viewer.graphql';

type Item = NonNullable<
    NonNullable<NonNullable<PdpRespUnavailableHeaderYMAL_viewer$data['topYMAL']>['edges']>[number]
>['node'];

const LANDING_CATEGORY = 'landing module interaction';

export const trackItemsDisplayed = (): void => {
    trackEvent({
        category: LANDING_CATEGORY,
        action: 'landing module displayed',
        label: 'related items - PDP_SIMILAR_ITEMS',
    });
};

const getProductTrackingData = (item: Item, index: number): Record<string, string | number> => {
    const { browseUrl, categoryCode, ecommerceTrackingParams, title } = item || {};
    return {
        list: 'sold pdp browse similar items',
        position: index + 1,
        category: browseUrl || '',
        categoryCode: categoryCode || '',
        ...(ecommerceTrackingParams || {}),
        name: SV.get('locale') === LOCALE_US ? title : 'n/a',
    };
};

export const trackItemImpressions = (items: Item[]): void => {
    trackEcommerce({
        type: trackingConstants.ECOM_PRODUCT_IMPRESSION,
        eventName: eventNameConstants.EVENT_VIEW_ITEM_LIST,
        products: items.map((item, index) => ({ ...getProductTrackingData(item, index) })),
    });
};

export const trackItemClick = (item: Item, index: number, event?: MouseEvent): void => {
    trackEvent(
        {
            category: LANDING_CATEGORY,
            action: 'landing module clicked',
            label: 'related items - PDP_SIMILAR_ITEMS',
        },
        event || null
    );

    trackEcommerce({
        type: trackingConstants.ECOM_PRODUCT_CLICK,
        eventName: eventNameConstants.EVENT_SELECT_ITEM,
        products: [
            {
                ...getProductTrackingData(item, index),
            },
        ],
        actionField: { list: 'sold pdp browse similar items', itemId: item?.serviceId },
    });
};
